export default function () {
  const widgetName = 'cardWidgetLogoDates';
  const widgetOpts = cardWidgetLogoDatesOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    cardWidgetLoaded: function () {
      // arguments: data, owl, hasData
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [],
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
